import LocalStorage from './localStorage';

export default class StorageManagement {
  static removeSensitiveData() {
    LocalStorage.token.remove();
    LocalStorage.state.remove();
  }
}
